import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';
import { DnRevenueService, NotificationService, KeywordService } from '../../../_services';

@Component({
  selector: 'app-dn-revenue-compatible',
  templateUrl: './dn-revenue-compatible.component.html'
})
export class DnRevenueCompatibleComponent implements OnInit {

  filterable = {
    from: null,
    to: null,
    source: null,
    country: null,
    reportType: 1,
    realtime: false
  };

  loading = false;
  loaded = false;
  processing = false;
  totalItems = 0;
  emptyResult = true;
  reports = {};
  reportTypeList = { 0: "By Keyword", 1: "By Client", 2: "By Share" }
  sourceList = [];
  selectedCountry = '';
  countryList: any = {};
  dataKeys = [];

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  constructor(private dnRevenueSvc: DnRevenueService,
    private keywordSvc: KeywordService,
    private notification: NotificationService) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadSources();
  }

  search(fileType) {
    this.loadPage(fileType);
  }

  changeSource(source) {
    if (source) {
      this.countryList = source.subOptions;
      var key = Object.keys(this.countryList)[0];
      var value = this.countryList[key];
      this.selectedCountry = value;
      this.filterable.country = value;
    }
  }

  changeCountry(country) {
    this.filterable.country = country;
    this.selectedCountry = country;
  }

  changeReportType(event) {
    this.loaded = false;
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source = currentSource
      this.countryList = currentSource.subOptions;
      var key = Object.keys(currentSource.subOptions)[0];
      var value = currentSource.subOptions[key];
      this.selectedCountry = value;
      this.filterable.country = value;
    });
  }

  private loadPage(fileType) {
    this.loading = true;
    this.emptyResult = false;
    this.reports = {};
    this.totalItems = 0;
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      source: this.filterable.source.value,
      country: this.filterable.country,
      reportType: this.filterable.reportType
    }
    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.dnRevenueSvc.getAllCompatible(params, this.filterable.realtime, fileType).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.reports = data.data;
        this.totalItems = Object.keys(this.reports).length;
        this.loaded = true;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this DN Revenue.", "Empty Result");
      }
    });
  }

}
